import styled from 'styled-components';
import React from 'react';
import ArticleCard from '../ArticleCard';
import { Article } from './types';

export default function ArticleCardTemplateSimple({
  title,
  author,
  createdAt,
  tags,
  hasVideo,
}: Article) {
  return (
    <ArticleCardTemplateSimpleCss>
      <ArticleCard.Title>{title}</ArticleCard.Title>
      <ArticleCardTemplateSimpleFooterCss>
        <ArticleCard.Meta author={author} createdAt={createdAt} />
        <ArticleCard.Footer tags={tags} hasVideo={hasVideo} />
      </ArticleCardTemplateSimpleFooterCss>
    </ArticleCardTemplateSimpleCss>
  );
}

const ArticleCardTemplateSimpleCss = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  & > span {
    padding: ${p => p.theme.sizes.spacing5};
  }
`;

const ArticleCardTemplateSimpleFooterCss = styled.div`
  padding: ${p =>
    `0 ${p.theme.sizes.spacing3} ${p.theme.sizes.spacing1} ${p.theme.sizes.spacing5} `};
  & > div:last-child {
    position: relative;
    right: -${p => p.theme.sizes.spacing2};
  }
`;
